module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0009-d849b0a13555bd73ce737bfc6ae6b760.jpg";